/* eslint-disable @typescript-eslint/no-explicit-any -- pre-existing legacy code, not touched in this pass; typing this properly is tracked separately */
import { useEffect } from "react";

const useEscape = (onEscape: any) => {
  useEffect(() => {
    const handleEsc = (event: any) => {
      if (event.keyCode === 27) onEscape();
    };
    document.addEventListener("keydown", handleEsc);

    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);
};

export default useEscape;
